<template>
    <div class="agent-manage" v-wechat-title="title">

        <div class="container">
            <div>
                <van-cell-group style="margin-bottom:10px;margin-top:10px;" class="group2" inset>
                    <van-field v-model.trim="agentName"  label="姓名" placeholder="请输入姓名" label-class="black-label" :readonly="isModify"/>
                    <van-cell :value="relation" class="" title="关系"  :is-link="!isModify"  @click="clickRelation">
                        <template>
                            <div :style="{'color':relation=='请选择关系'?'#c8c9cc':'black','text-align':'left'}">{{relation}}</div>
                        </template>
                    </van-cell>
                    <van-popup v-model="showRelation" round  position="bottom">
                        <van-picker show-toolbar :columns="relationArr" @cancel="showRelation = false" @confirm="confirmRelation" />
                    </van-popup>
                     <van-cell class="" title="证件类型" >
                        <van-radio-group v-model="radio2" direction="horizontal" :disabled="isModify">
                            <van-radio name="身份证" checked-color="#0AA8AF" style="margin:2px 5px 2px 0;">身份证</van-radio>
                            <van-radio name="军官证" checked-color="#0AA8AF" style="margin:2px;">军官证</van-radio>
                        </van-radio-group>
                    </van-cell>
                    <van-field v-model="idsn" label="证件号码" placeholder="请输入您的证件号码" :readonly="isModify" :error="idsnErr"/>
                </van-cell-group>

                <van-cell-group style="margin-bottom: 10px;" class="group2" inset>
                    <van-cell>
                        <!-- <template #title> -->
                            <div >照片</div>
                                <image-uploader ref="imgUploader" :value="photoArr" @input="getPhoto" title=" " :num="1" @deleteCI="deleteCI" :history="imgs"></image-uploader>
                        <!-- </template> -->
                    </van-cell>
                </van-cell-group>
            <div style="font-size:14px;margin:10px 21px;display:flex;justify-content:center;align-items:flex-start;">
                <van-checkbox v-model="checked" shape="square" icon-size="16px" style="padding:3px 10px 0 0;"></van-checkbox>
                <div style="text-align:left;" @click="checked=true">勾选代表您自愿接受并同意<span style="color:#0AA8AF;" @click="showContract=true">《择美同行患者援助项目隐私政策》</span></div>
            </div>

            </div>

            <div class="btn">
                <van-button type="default" class="btn1" plain round @click="$router.go(-1)" color="#0AA8AF" :disabled="disabled" >
                返回</van-button>
                <van-button type="default" class="btn2" round @click="submitAgent" color="#0AA8AF" :disabled="disabled" >
                提交并保存</van-button>
            </div>
        </div>

        <van-popup class="popup" v-model="showContract" position="bottom" >
            <div class="contract-box">
                <!-- <div class="contract-title">《患者知情同意书》</div> -->
                <div class="contract-text" id="text" >
                    <div v-html="contractText"></div>
                
                </div>
                    <div class="btn-group">
                        <van-button type="default" class="btn1" plain round @click="showContract=false" color="#0AA8AF">
                        返回</van-button>
                    </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import { checkFamily,addFamily } from '@/api/patient'
import { pageInfo } from '@/api/api'
import { Toast,Divider,Dialog } from 'vant'
import Vue from "vue";
import { mapState } from "vuex";
import { isIdCardNo } from "@/utils/utils";
import ImageUploader from "@/views/apply/ImageUploader3";
Vue.use(Toast)
Vue.use(Divider);
Vue.use(Dialog);


export default {
    name:"agentManage",
    components:{ImageUploader},
    data(){
        return {
            title:'新增代领药人',
            showContract:false,
            contractText:'',

            papid:'',
            baseUrl:'http://zmtx.papv2.sungotech.com',

            disabled:false,

            agentName:'',
            relation:'请选择关系',
            showRelation:false,
            relationArr:["配偶", "父母", "子女", "亲属", "同事", "其他"],
            radio2:'',
            idsn:'',
            idsnErr:false,
            photoArr:[],
            imgs:[],

            isModify:false,//修改or新增

            checked:false,//勾选隐私协议

            family_id:'',//代领药人id 修改标识

        }
    },
    computed: {
        ...mapState(['patientOne', 'userInfo','patientInfo']),
    },
    async created(){
        Toast.loading({ duration: 0,  forbidClick: true });

        this.papid=this.patientOne.papid;
        if(this.$route.query.idsn){//是修改
            this.isModify=true
            this.title='修改代领药人'
            console.log("修改代领药人")
        }else{
            this.isModify=false
            this.title='新增代领药人'
            console.log("新增代领药人")
        }
        await this.getData();

        Toast.clear()
    },
    methods: {
        async getData(){
            //修改信息回显
            await pageInfo({ params: { "PageSearch[title]": "隐私协议" }}).then((res) => {
                if(res){
                    this.contractText = res.data.items[0].content
                    // console.log(res.data.items[0].content)
                }else{
                    console.log("获取隐私协议-res不存在",res)
                }
            }).catch(err=>{
                console.log("获取隐私协议-错误",err)
            })
            if(!this.$route.query.idsn) return
            await checkFamily({
                idsn:this.$route.query.idsn
            }).then(res=>{
                if(res.data){
                    console.log("checkFamily",res.data)
                    let DATA=res.data;
                    this.agentName=DATA.name;
                    this.relation=DATA.relation
                    this.radio2=DATA.id_type
                    this.idsn=DATA.idsn
                    this.family_id=DATA.id
                    this.imgs=DATA.idsn_pic?[{filepath:DATA.idsn_pic.indexOf('http')>=0?DATA.idsn_pic:this.baseUrl+DATA.idsn_pic}]:[]
                    console.log("this.photoArr",this.photoArr)
                    this.$forceUpdate()
                }
            })
        },
        clickRelation(){
            if(this.isModify==true) return
            this.showRelation=true
        },
        confirmRelation(value){
            this.relation=value
            this.showRelation=false
        },
        checkIdsn() {
            console.log("radio2:",this.radio2)
            if(this.radio2!='身份证'){
                console.log("不验证")
                this.idsnErr = false
                return true
            }
            if (!isIdCardNo(this.idsn)) {
                console.log("no")
                this.idsnErr = true
                // Toast('请输入正确的身份证号码！')
                return false;
            } else {
                console.log("yes")
                this.idsnErr = false
                return true
            }
        },
        getPhoto(){

        },
        deleteCI(id){
            Dialog.confirm({
                message: '确定删除？',
                confirmButtonColor:'#0AA8AF',
            })
            .then(() => {
                // this.photoArr=[]
                this.imgs=[]
                this.$forceUpdate()
            })
        },
        async submitAgent(){//新增/修改代领药人
            if(this.isModify){
                //修改
                if(!this.checked){
                    Toast({ message: '请同意《隐私协议》\n后再提交', icon: 'info-o',className:'addAgentToast' });
                    return
                }
                console.log("修改图片",this.photoArr[0],this.imgs[0])
                let idsn_pic=this.photoArr[0]?this.photoArr[0].src:this.imgs[0]?this.imgs[0].filepath:''
                if(!idsn_pic){
                    Toast({ message: '请完善信息再提交', icon: 'info-o', });
                    return
                }
                let sendData={
                    papid: this.papid,
                    name: this.agentName,
                    idsn: this.idsn,
                    relation: this.relation,
                    idsn_pic: idsn_pic,
                    family_id:this.family_id
                }
                console.log("addFamily发送数据",sendData)
                Toast.loading({
                    duration: 0, // 持续展示 toast
                    forbidClick: true
                });
                await addFamily(sendData).then((res) => {
                    Toast.clear();
                    if(res.data){
                        console.log("addFamily",res.data)
                        Toast.success('修改成功');
                        this.$router.go(-1);
                    }
                }).catch(err => {
                    Toast.clear();
                    if(err.response) Toast({ message: err.response.data.message, icon: 'info-o', })
                })
                
            }else{
                //新增
                let idsn_pic=this.photoArr[0]?this.photoArr[0].src:''
                if(!this.agentName||!this.idsn||!this.relation||!this.radio2||!idsn_pic){
                    Toast({ message: '请完善信息再提交', icon: 'info-o', });
                    return
                }
                // console.log("idsnErr:",this.idsnErr,"radio2:",this.radio2)
                this.checkIdsn()
                if(this.idsnErr){
                    Toast({ message: '请输入正确的身份证号码', icon: 'info-o',className:'addAgentToast' })
                    return
                }
                if(!this.checked){
                    Toast({ message: '请同意《隐私协议》\n后再提交', icon: 'info-o',className:'addAgentToast' });
                    return
                }
                // let stopSubmit=false
                // await checkFamily({ idsn:this.idsn }).then(res=>{
                //     if(res.data){
                //         console.log("checkFamily-该身份号已被占用",res.data)
                //         Toast({ message: '该身份号已被占用', icon: 'info-o', });
                //         stopSubmit=true
                //     }
                // })
                // if(stopSubmit) return

                let sendData={
                    papid: this.papid,
                    name: this.agentName,
                    idsn: this.idsn,
                    relation: this.relation,
                    idsn_pic: idsn_pic
                }
                console.log("addFamily发送数据",sendData)
                Toast.loading({
                    duration: 0, // 持续展示 toast
                    forbidClick: true
                });
                await addFamily(sendData).then((res) => {
                    if(res.data){
                        Toast.clear();
                        console.log("addFamily",res.data)
                        Toast.success('新增成功');
                        this.$router.go(-1);
                    }
                }).catch(err => {
                    Toast.clear();
                    if(err.response) Toast({ message: err.response.data.message, icon: 'info-o', })
                })
                
            }
        },
    },
    
}

</script>
<style lang="less">
.addAgentToast{
    min-width:130px;
}
</style>
<style lang="less" scoped>
.agent-manage{
    min-height:100vh;
    .container{
        min-height:100vh;
        display: flex;
        flex-flow: column wrap;
        justify-content:space-between;
        .group2{
            box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
            .van-cell__value{
                // flex:2 0 !important;
            }
            ::v-deep .van-cell__title{
                max-width: 100px!important;
            }
            
        }
        .contain-cell{
            // box-shadow: 0 0 8px  rgba(0, 0, 0, 0.15);
            box-shadow: 0px 1px 10px 0px rgba(3, 121, 255, 0.1);
            border-radius: 8px;
            display: flex;
            flex-flow: column nowrap;
            justify-content:center;
            align-items:center;
            margin: 20px 16px 10px 16px;
            .van-cell{
                border-radius: 8px;
            }
            .timer{
                &::after{
                    border-bottom:none !important;
                }
                .van-cell__value{
                    flex:1 0;
                }
                .van-cell__title{
                    flex:2 0;
                }
            }
        }
        .patient_list{
            margin-top: 18px;
            padding-bottom: 44px;
            .van-cell{
                display: flex;
                justify-content: center;
                align-items: center;
                // .van-cell__title{
                // }
                .van-cell__value{
                    height:100%;
                    .btn-contain{
                        height:100%;
                    }
                }
            }
            .patient_info{
                display: flex;
                .flex-center-col{
                    display: flex;
                    flex-flow: column nowrap;
                    justify-content: center;
                    align-items: flex-start;
                }
                .flex-center-row{
                    display: flex;
                    flex-flow: row nowrap;
                    justify-content: flex-start;
                    align-items: center;
                }
                .avatar{
                    margin:0 10px;
                }
            }
            .add_btn{
                position:fixed;
                bottom:0;
                width:100%;
            }
            
            }
    }
    .popup{
        min-height:100vh;
        display:flex;
        align-items:space-between;
        .contract-box {
            position: relative;
            display: flex;
            flex-direction: column;

            // .contract-title {
            //     background: #fff;
            //     box-sizing: content-box;
            //     width: auto;
            //     line-height: 24px;
            //     height: 24px;
            //     font-size: 1.6rem;
            //     text-align: center;
            //     padding: 20px 50px 10px;
            //     background: #fff;
            // }

            .contract-text {
                flex: 1;
                font-size: 1.4rem;
                text-align: justify;
                line-height: 1.5;
                padding: 15px;
                overflow-y: auto;
                transition: transform .3s;
                -webkit-overflow-scrolling: touch;
            }
        }
    }
    .btn-group{
        display: flex;
        padding: 16px;
        button{
            width: 100%;
        }
    }
    .flex-col{
        display: flex;
        flex-flow: column nowrap;
        button{
            margin-bottom: 10px;
        }
    }


    .btn{
      display: flex;
      justify-content:space-between;
      width: 100%;
      padding: 10px;
      // background-color: white;
      margin: 0;
      .van-button{
        margin: 0 5px;
        white-space: nowrap;
      }
      .btn1{flex-grow: 1;}
      .btn2{flex-grow: 4;}
    }
}
</style>